import { render, staticRenderFns } from "./mdModalAddGoal.vue?vue&type=template&id=383d6872&"
import script from "./mdModalAddGoal.vue?vue&type=script&lang=js&"
export * from "./mdModalAddGoal.vue?vue&type=script&lang=js&"
import style0 from "./mdModalAddGoal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports